import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { NewMeetingDialog } from "./boardroom/NewMeetingDialog";
import { AnnualWheelSection } from "./boardroom/AnnualWheelSection";
import { BoardMembersPanel } from "./boardroom/BoardMembersPanel";
import { MeetingsList } from "./boardroom/MeetingsList";

export default function Boardroom() {
  const { companyId } = useParams();
  const [meetings, setMeetings] = useState(null);
  const [members, setMembers] = useState(null);

  const load = useCallback(() => api.get(`/companies/${companyId}/meetings`).then((r) => setMeetings(r.data)), [companyId]);

  useEffect(() => {
    setMeetings(null);
    setMembers(null);
    load();
    api.get(`/companies/${companyId}/members`).then((r) => setMembers(r.data)).catch(() => setMembers([]));
  }, [companyId, load]);

  return (
    <div className="mx-auto max-w-6xl">
      <PageHeader title="Styrerom" description="Oversikt over styret og møtene gjennom året. Alt samlet med sakliste, protokoll og signering.">
        <NewMeetingDialog companyId={companyId} />
      </PageHeader>

      {/* Oversikt: årshjul + styret */}
      <div className="mb-8 grid gap-5 lg:grid-cols-5">
        <AnnualWheelSection companyId={companyId} meetings={meetings} onApplied={load} />
        <BoardMembersPanel members={members} />
      </div>

      <div className="mb-3 flex items-center gap-2">
        <h2 className="font-headings text-lg font-bold tracking-tight">Alle møter</h2>
        <span className="rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground">{meetings ? meetings.length : ""}</span>
      </div>

      <MeetingsList meetings={meetings} companyId={companyId} />
    </div>
  );
}
